import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import type { TStencilStore } from '@src/types/Stencil';
import { PageContentDispatchContext, PageContentStateContext } from '../wysiwyg/page_content';
import { TextCacheProvider } from '../wysiwyg/text_cache';
import type { TPageContentItem } from '@src/types/wysiwyg_editor';

interface Props {
  children: React.ReactElement;
}

export const PageContentProvider = ({ children }: Props): React.ReactElement => {
  const [selectedPageContentItemId, setSelectedPageContentItemId] = useState<string>(null);
  const [selectedPageContentItem, setSelectedPageContentItem] = useState<TPageContentItem>(null);

  const contentItems = useSelector((state: TStencilStore) => state.submission.pageContentItems);

  const lastHistoryWalk = useSelector((state: TStencilStore) => state.pageState.lastHistoryWalk);

  const layoutTemplateName = useSelector((state: TStencilStore) => state.submission.layoutTemplateName);

  const getItemById = useCallback((id: string) => contentItems.find((item) => item.id === id), [contentItems]);

  useEffect(() => {
    setSelectedPageContentItem(
      selectedPageContentItemId ? contentItems.find((item) => item.id === selectedPageContentItemId) : null
    );
  }, [selectedPageContentItemId, contentItems]);

  return (
    <PageContentDispatchContext.Provider value={{ getItemById, setSelectedPageContentItemId }}>
      <PageContentStateContext.Provider
        value={{
          contentItems,
          lastHistoryWalk,
          layoutTemplateName,
          selectedPageContentItem
        }}
      >
        <TextCacheProvider>{children}</TextCacheProvider>
      </PageContentStateContext.Provider>
    </PageContentDispatchContext.Provider>
  );
};
